<script setup>
import {ref} from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    value: {
        type: Number,
        required: true,
    },
    size: {
        type: String,
        default: 'md',
    },
    variant: {
        type: String,
        default: 'orange-400',
    },
    maxValue: {
        type: Number,
        default: 5,
    },
    halfValues: {
        type: Boolean,
        default: false,
    },
    allowZero: {
        type: Boolean,
        default: true,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
});

const modelValue = ref(Math.min(props.value, props.maxValue));
const steps = Array(props.maxValue * (props.halfValues ? 2 : 1))
    .fill(0)
    .map((_, i) => (i + 1) * (props.halfValues ? 0.5 : 1));
const halfMask = (index) => (props.halfValues ? `mask-half-${Number.isInteger(index) ? 2 : 1}` : '');

const emit = defineEmits(['update:modelValue']);

const onUpdated = (value) => {
    emit('update:modelValue', value);
};
</script>
<template>
    <div class="rating flex align-middle" :class="[{'rating-half': halfValues}, `rating-${props.size ?? 'md'}`]">
        <input
            v-if="allowZero"
            v-model="modelValue"
            type="radio"
            :value="0"
            :name="name"
            :disabled="readonly"
            :aria-label="`${name} 0`"
            class="rating-hidden bg-transparent text-transparent !border-transparent !ring-transparent"
            :class="{'cursor-default': props.readonly}"
            @input="onUpdated(0)" />
        <input
            v-for="index in steps"
            :key="index"
            v-model="modelValue"
            type="radio"
            :value="index"
            :name="name"
            :aria-label="`${name} ${index}`"
            :disabled="readonly"
            class="mask mask-star-2 !border-transparent"
            :class="[{'cursor-default': props.readonly}, halfMask(index), `text-${props.variant} bg-${props.variant}`]"
            @input="onUpdated(index)" />
    </div>
</template>
